import { createApp, h } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App);

// 多言語対応
import { createI18n } from "vue-i18n";
import { data } from "@/lib/lang/index.js";
const i18n = createI18n({
  locale: "ja",
  fallbackLocale: "ja",
  messages: data,
  silentFallbackWarn: true,
});
app.use(i18n);

// Vue Spinner
import PulseLoader from "vue-spinner/src/PulseLoader";
app.component("PulseLoader", PulseLoader);

// vue-qrcode （passでのみ使用中）
import VueQrcode from "@chenfengyuan/vue-qrcode";
app.component(VueQrcode.name, VueQrcode);

import "./registerServiceWorker";

// moment.js
const moment = require("moment-timezone");
require("moment/locale/ja");
moment.tz.setDefault("Asia/Tokyo");
app.config.globalProperties.$moment = moment;
// Vue.use(require("vue-moment"), {
//  moment
// });

import VCalendar from "v-calendar";
app.use(VCalendar, {});

// コンポーネントの一括登録
const files = require.context("./views/Components", true, /\.vue$/);
const components = {};
files.keys().forEach((key) => {
  components[key.replace(/(\.\/|\.vue)/g, "")] = files(key).default;
});
console.log("components :>> ", components);
Object.keys(components).forEach((key) => {
  app.component(components[key].name, components[key]);
});

// グローバルミックスインをインポートしてVueへ適用
import mergeMixin from "@/mixins/MergeMixin";
app.mixin(mergeMixin);

app.use(router);
app.use(store);
app.mount("#app");

import Axios from "axios";

Axios.interceptors.request.use((request) => {
  console.log("Starting Request: ", request);
  try {
    console.log(
      `Starting Request: ${request.method.toUpperCase()} ${request.url}`
    );
  } catch (err) {
    console.log("err", err);
  }
  return request;
});

Axios.interceptors.response.use(
  (response) => {
    console.log("Response: ", response);
    try {
      console.log("Response status: ", response.status);
    } catch (err) {
      console.log("err", err);
    }
    return response;
  },
  (error) => {
    console.log("axios error:", error);
    try {
      console.log(
        `axios error: ${error.response.status} ${error.request.method} ${error.request.res.responseUrl}`
      );
    } catch (err) {
      console.log("err", err);
    }

    return Promise.reject(error);
  }
);

function noScroll(event) {
  event.preventDefault();
}

// // スクロール禁止
app.config.globalProperties.$noScroll = function () {
  // SP
  document.addEventListener("touchmove", noScroll, { passive: false });
  // PC
  document.addEventListener("mousewheel", noScroll, { passive: false });
};

// // スクロール禁止を解除
app.config.globalProperties.$returnScroll = function () {
  // SP
  document.removeEventListener("touchmove", noScroll, { passive: false });
  // PC
  document.removeEventListener("mousewheel", noScroll, { passive: false });
};
